import { useDashboardFilters } from '@/features/dashboard/filters/useDashboardFilters'
import { useDashboardCard } from '@/features/dashboard/api/queries'

/** A card sliced by the dashboard filters, plus the way to clear its market filter. */
export const useFilteredCard = (cardId: number) => {
  const { periods, markets, clearMarkets } = useDashboardFilters()
  const query = useDashboardCard(cardId, { periods, markets })
  return { ...query, clearMarkets }
}
